import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import { AppContext } from '../context/AppContext';

// ── Icons ─────────────────────────────────────────────────────────────────────
const Icon = ({ d, d2 }) => (
    <svg className="w-[17px] h-[17px] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}>
        <path strokeLinecap="round" strokeLinejoin="round" d={d} />
        {d2 && <path strokeLinecap="round" strokeLinejoin="round" d={d2} />}
    </svg>
);

const Icons = {
    home:     <Icon d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75" />,
    users:    <Icon d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.49M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />,
    cube:     <Icon d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />,
    truck:    <Icon d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.25a2.25 2.25 0 00-2.25 2.25v6m-4.5 0v-6a2.25 2.25 0 00-2.25-2.25h-3" />,
    card:     <Icon d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />,
    chart:    <Icon d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />,
    sparkles: <Icon d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />,
    settings: <Icon d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 010 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 010-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28z" d2="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />,
    lock:     <Icon d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />,
    signout:  <Icon d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />,
    chevron:  <Icon d="M8.25 4.5l7.5 7.5-7.5 7.5" />,
    close:    <Icon d="M6 18L18 6M6 6l12 12" />,
};

const Sidebar = ({ onClose }) => {
    const { selectedDepo, setSelectedDepo, depos, user, logout } = useContext(AppContext);
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [openSection, setOpenSection] = useState(null);

    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    const navSections = [
        {
            id: 'main',
            label: t('MAIN'),
            icon: Icons.home,
            children: [
                { path: '/', label: t('Sales Overview') },
                { path: '/pos', label: t('POS (Point of Sale)'), badge: 'Hot' },
            ]
        },
        {
            id: 'customers',
            label: t('CUSTOMERS'),
            icon: Icons.users,
            children: [
                { path: '/customers', label: t('Customer Credit Accounts') },
                { path: '/sales', label: t('Accounts') },
                { path: '/gift-cards', label: t('Gift Cards') },
            ]
        },
        {
            id: 'inventory_warehouse',
            label: t('INVENTORY & WAREHOUSE'),
            icon: Icons.cube,
            children: [
                { path: '/products', label: t('Product List') },
                { path: '/products/intake', label: t('Purchase Intake') },
                { path: '/inventory', label: t('Inventory Analytics') },
                { path: '/transfers', label: t('Stock Movements') },
                { path: '/control-inventory', label: t('Inventory Control') },
                { path: '/low-stock', label: t('Low Stock Alerts'), badge: 'Alert' },
                { path: '/products-tracking', label: t('Products Tracking'), badge: 'New' },
                { path: '/purchase-orders', label: t('Purchase Orders') },
            ]
        },
        {
            id: 'suppliers_procurement',
            label: t('SUPPLIERS & PROCUREMENT'),
            icon: Icons.truck,
            children: [
                { path: '/purchases/new', label: t('New Purchase (Achats)') },
                { path: '/purchases/today', label: t('Today\'s Purchases') },
                { path: '/purchases', label: t('Purchase Register') }
            ]
        },
        {
            id: 'accounting_finance',
            label: t('ACCOUNTING & FINANCE'),
            icon: Icons.card,
            children: [
                { path: '/accounting', label: t('Financial Dashboard') },
                { path: '/owner-settlement', label: t('Owner Settlement') },
                { path: '/accounts', label: t('Chart of Accounts') },
                { path: '/journal', label: t('Ledger & Journal') },
            ]
        },
        {
            id: 'reporting_analytics',
            label: t('REPORTING & ANALYTICS'),
            icon: Icons.chart,
            children: [
                { path: '/reports/performance', label: t('Performance Overview'), badge: 'Pro' },
                { path: '/reports/closing-matrix', label: t('Daily & Monthly Matrix') },
                { path: '/reports/audit-alerts', label: t('Financial Audit & Alerts') },
            ]
        },
        {
            id: 'ai_tools',
            label: t('AI TOOLS'),
            icon: Icons.sparkles,
            children: [
                { path: '/ai-excel', label: t('Systems Builder') },
            ]
        },
        {
            id: 'system',
            label: t('SYSTEM'),
            icon: Icons.settings,
            children: [
                { path: '/settings', label: t('Settings') },
            ]
        }
    ];

    if (user?.role === 'Admin') {
        navSections.push({
            id: 'admin',
            label: t('ADMINISTRATION'),
            icon: Icons.lock,
            children: [
                { path: '/audit', label: t('Security & Audit') },
                { path: '/users', label: t('User Management') }
            ]
        });
    }

    let displaySections = navSections;
    if (user?.role === 'Cashier') {
        displaySections = [
            {
                id: 'cashier_main',
                label: t('CASHIER'),
                icon: Icons.home,
                children: [
                    { path: '/pos', label: t('POS (Point of Sale)'), badge: 'Hot' },
                    { path: '/products', label: t('Check Price') }
                ]
            }
        ];
    }

    useEffect(() => {
        displaySections.forEach(sec => {
            if (sec.children?.some(child => location.pathname === child.path)) {
                setOpenSection(sec.id);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = lng;
    };

    const badgeStyle = (badge) => {
        if (badge === 'Alert') return 'bg-red-500/20 text-red-300 border border-red-500/20';
        if (badge === 'Hot')   return 'bg-orange-500/20 text-orange-300 border border-orange-500/20';
        return 'bg-[#5b6af0]/20 text-[#9ba5f7] border border-[#5b6af0]/20';
    };

    return (
        <div className="w-64 bg-erp-sidebar text-slate-300 h-full flex flex-col border-r border-erp-sidebar-border overflow-hidden md:relative fixed top-0 left-0 z-50">

            {/* Mobile close */}
            <div className="md:hidden flex justify-end p-3 pb-0">
                <button
                    onClick={onClose}
                    className="p-1.5 rounded-lg text-slate-500 hover:text-slate-200 hover:bg-erp-sidebar-hover transition-colors"
                    aria-label="Close sidebar"
                >
                    {Icons.close}
                </button>
            </div>

            {/* Header / Logo */}
            <div className="px-5 pt-5 pb-4">
                <div className="flex items-center gap-2.5 mb-5">
                    {/* Simple, clean logo mark */}
                    <div className="w-8 h-8 rounded-lg bg-[#5b6af0] flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold text-sm">R</span>
                    </div>
                    <div>
                        <h1 className="text-[15px] font-bold text-white leading-none tracking-tight">
                            Royal<span className="text-[#9ba5f7]">Pips</span>
                        </h1>
                        <p className="text-[10px] text-slate-500 mt-0.5 font-medium">{t('ERP System')}</p>
                    </div>
                </div>

                {/* Language Switcher */}
                <div className="flex bg-erp-sidebar-hover rounded-lg p-1 gap-0.5 border border-erp-sidebar-border">
                    {['en', 'fr', 'ar'].map(lng => (
                        <button
                            key={lng}
                            onClick={() => changeLanguage(lng)}
                            className={`flex-1 py-1 rounded text-[11px] font-semibold transition-all ${
                                i18n.language === lng
                                    ? 'bg-[#5b6af0] text-white'
                                    : 'text-slate-500 hover:text-slate-300'
                            }`}
                        >
                            {lng === 'ar' ? 'عربي' : lng.toUpperCase()}
                        </button>
                    ))}
                </div>
            </div>

            {/* Branch Selector */}
            <div className="px-5 pb-4">
                <div className="bg-erp-sidebar-hover rounded-lg p-2.5 border border-erp-sidebar-border">
                    <label className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold block mb-1">
                        {t('Active Branch')}
                    </label>
                    <select
                        className="w-full bg-transparent text-sm text-slate-200 focus:outline-none font-medium cursor-pointer appearance-none"
                        value={selectedDepo}
                        onChange={(e) => setSelectedDepo(e.target.value)}
                    >
                        <option value="Global" className="bg-[#1c2233]">{t('All Locations')}</option>
                        {Array.from(new Map((depos || []).map(d => [d.name, d])).values()).map(depo => (
                            <option key={depo.id} value={depo.id} className="bg-[#1c2233]">{depo.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Navigation */}
            <nav className="flex-1 overflow-y-auto sidebar-scroll px-3 pb-3 space-y-0.5">
                {displaySections.map(sec => {
                    const hasChildren = sec.children && sec.children.length > 0;
                    const isOpen = openSection === sec.id;
                    const isDirectActive = sec.path && location.pathname === sec.path;

                    if (!hasChildren) {
                        return (
                            <NavLink
                                key={sec.id}
                                to={sec.path}
                                className={({ isActive }) =>
                                    `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                                        isActive
                                            ? 'bg-erp-sidebar-active text-white'
                                            : 'text-slate-400 hover:bg-erp-sidebar-hover hover:text-slate-200'
                                    }`
                                }
                            >
                                <span className={isDirectActive ? 'text-[#9ba5f7]' : 'text-slate-500'}>{sec.icon}</span>
                                <span>{sec.label}</span>
                            </NavLink>
                        );
                    }

                    return (
                        <div key={sec.id}>
                            <button
                                onClick={() => toggleSection(sec.id)}
                                className={`w-full flex items-center justify-between gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                                    isOpen
                                        ? 'text-slate-200 bg-erp-sidebar-hover'
                                        : 'text-slate-400 hover:bg-erp-sidebar-hover hover:text-slate-200'
                                }`}
                            >
                                <div className="flex items-center gap-2.5">
                                    <span className={isOpen ? 'text-[#9ba5f7]' : 'text-slate-500'}>{sec.icon}</span>
                                    <span className={`text-[12.5px] font-semibold tracking-wide ${isOpen ? 'text-slate-100' : ''}`}>
                                        {sec.label}
                                    </span>
                                </div>
                                <span className={`transition-transform duration-200 text-slate-600 ${isOpen ? 'rotate-90' : ''}`}>
                                    {Icons.chevron}
                                </span>
                            </button>

                            {/* Sub items */}
                            <div className={`overflow-hidden transition-all duration-200 ${isOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'}`}>
                                <ul className="mt-0.5 mb-1 pl-9 space-y-0.5 relative before:absolute before:left-[1.55rem] before:top-1 before:bottom-1 before:w-px before:bg-erp-sidebar-border">
                                    {sec.children.map(child => (
                                        <li key={child.path}>
                                            <NavLink
                                                to={child.path}
                                                className={({ isActive }) =>
                                                    `flex items-center justify-between py-1.5 px-2 rounded-md text-[12.5px] transition-colors ${
                                                        isActive
                                                            ? 'text-white bg-erp-sidebar-active font-medium'
                                                            : 'text-slate-500 hover:text-slate-200 hover:bg-erp-sidebar-hover'
                                                    }`
                                                }
                                            >
                                                <span>{child.label}</span>
                                                {child.badge && (
                                                    <span className={`px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider ${badgeStyle(child.badge)}`}>
                                                        {child.badge}
                                                    </span>
                                                )}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    );
                })}
            </nav>

            {/* User Footer */}
            <div className="p-3 border-t border-erp-sidebar-border">
                <div className="flex items-center justify-between bg-erp-sidebar-hover rounded-lg p-2.5 border border-erp-sidebar-border">
                    <div className="flex items-center gap-2.5 min-w-0">
                        <div className="w-7 h-7 rounded-md bg-[#5b6af0]/30 border border-[#5b6af0]/30 flex items-center justify-center text-xs font-bold text-[#9ba5f7] flex-shrink-0 uppercase">
                            {user?.name?.charAt(0) || 'U'}
                        </div>
                        <div className="min-w-0">
                            <p className="text-xs font-semibold text-slate-200 truncate">{user?.name || t('User')}</p>
                            <p className="text-[10px] text-slate-500 capitalize">{user?.role || t('Staff')}</p>
                        </div>
                    </div>
                    <button
                        onClick={logout}
                        title={t('Sign Out')}
                        className="p-1.5 text-slate-500 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors flex-shrink-0"
                    >
                        {Icons.signout}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
